module.exports = __webpack_public_path__ + "static/media/agro jabar.d27a76d5.png";